var Industry = "Setor";
var Aerospace = "Aeroespacial";
var Agriculture = "Agricultura";
var Automotive = "Automotivo";
var Education = "Educação";
var Gaming = "Jogos";
var Government = "Governo";
var Healthcare = "Saúde";
var Hospitality = "Hotelaria";
var Manufacturing = "Manufatura";
var Mining = "Mineração";
var Other = "Outros";
var Retail = "Varejo";
var Telecommunications = "Telecomunicações";
var Travel = "Viagens";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "Computadores e eletrônicos",
	"Consumer goods": "Bens de consumo",
	Education: Education,
	"Financial services": "Serviços financeiros",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "Life Sciences (Ciências biológicas)",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "Marketing e publicidade",
	"Media & entertainment": "Mídia e entretenimento",
	Mining: Mining,
	"Non-profit organization": "Organização sem fins lucrativos",
	"Oil & gas": "Petróleo e gás",
	Other: Other,
	"Power & utilities": "Energia e serviços públicos",
	"Professional services": "Serviços profissionais",
	"Real estate & construction": "Imóveis e construção",
	Retail: Retail,
	"Software & internet": "Software & Internet",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "Transportes e logística",
	Travel: Travel,
	"Wholesale & distribution": "Atacado e distribuição"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
